import { useToast } from 'src/shared/hooks/use-toast'

import { useMarkAllNotificationsAsRead } from '../api/use-mark-all-as-read'
import { EnvelopeIcon } from '../icons/envelope-icon'

const MarkAllAsReadButton = () => {
  const { mutateAsync: markAllAsRead, isPending: isMarkingAllAsRead } = useMarkAllNotificationsAsRead()
  const { toast } = useToast()

  const onMarkAllAsRead = async () => {
    try {
      const response = await markAllAsRead()

      if (!response) {
        throw new Error('Failed to mark all notifications as read')
      }
      toast({
        title: 'Success',
        description: response.message,
        variant: 'default',
      })
    } catch (error) {
      console.error('Error marking all notifications as read:', error)
      toast({
        title: 'Error',
        description: error instanceof Error ? error.message : 'Failed to mark all notifications as read',
        variant: 'destructive',
      })
    }
  }

  return (
    <button
      className="flex flex-row items-center gap-2 text-primary"
      disabled={isMarkingAllAsRead}
      onClick={onMarkAllAsRead}
    >
      <EnvelopeIcon className="size-3.5 text-primary" />
      <p className="text-[13px] leading-[18px] text-primary">Mark all as read</p>
    </button>
  )
}

export default MarkAllAsReadButton
